import { Auth0Provider, withAuthenticationRequired } from "@auth0/auth0-react";
import { ReactElement } from "react";
import { useNavigate } from "react-router-dom";

export const ProtectedRoute = ({ component, ...args }: any) => {
  const Component = withAuthenticationRequired(component, args);
  return <Component />;
};

export const Auth0ProviderWithRedirectCallback = ({ children }: { children: ReactElement}) => {
  const navigate = useNavigate();

  return (
    <Auth0Provider
      useRefreshTokens
      cacheLocation="localstorage"
      domain={`${process.env.REACT_APP_AUTH0_DOMAIN}`}
      clientId={`${process.env.REACT_APP_AUTH0_CLIENT_ID}`}
      authorizationParams={{
        redirect_uri: `${window.location.origin}`,
        audience: `${process.env.REACT_APP_AUTH0_AUDIENCE}`
      }}
      onRedirectCallback={() => {
        navigate("/team", { replace: true });
      }}
    >
      {children}
    </Auth0Provider>
  );
};